import logo from '../assets/logos/logo.svg';

function Logo() {
    return <img src={logo} alt="x-flix" />;
}

export default Logo;